import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import ShelfIndex from "./components/ShelfIndex";
import Collections from "./components/Collections";
import HotRank from "./components/HotRank";
import NewArrivals from "./components/NewArrivals";
import Guide from "./components/Guide";
import About from "./components/About";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-[#f5efe4] text-[#241f18]">
      <Masthead />
      <main className="w-full">
        <Hero />
        <ShelfIndex />
        <Collections />
        <HotRank />
        <NewArrivals />
        <Guide />
        <About />
      </main>
      <SiteFooter />
    </div>
  );
}